import { isEmpty } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { FlexCol } from '../../../../components/structure/FlexGrid'
import { useActionPlans } from './_data/actionPlans'
import { useActionPlansReplies } from './_data/actionPlansReplies'
import { useIsPermalinkPage } from '../../../../utils/session/permalinkToken'
import Accordion from '../../../../components/structure/Accordion'
import ActionPlanCard from './ActionPlanCard'
import DynamicListCounters from '../../../../containers/dynamic/presentationList/DynamicListCounters'

const ActionPlansAccordion = () => {
  const { t } = useTranslation('serviceOrders')
  const isPublic = useIsPermalinkPage()
  const replies = useActionPlansReplies()
  const actionPlans = useActionPlans()
  if (isPublic || isEmpty(replies)) return false

  return (
    <FlexCol>
      <Accordion label={t('resume.accordion.actionPlans')} side={<DynamicListCounters replies={replies} />}>
        {actionPlans.map((actionPlan, index) => (
          <ActionPlanCard key={index} actionPlan={actionPlan} />
        ))}
      </Accordion>
    </FlexCol>
  )
}

export default ActionPlansAccordion
